module.exports = __webpack_public_path__ + "static/media/Draw.c9da49dc.svg";